import interact from 'interactjs'
import m from 'mithril'

class RangeSlider {
  constructor(vnode) {
    this.left = 0
    this.right = 0
    this.rangeWidth = 200
    //租金最大最小範圍
    this.min = vnode.attrs.min
    this.max = vnode.attrs.max
    //租金設定範圍
    this.start = vnode.attrs.start
    this.end = vnode.attrs.end

  }
  oncreate(vnode) {
    const _range = vnode.dom.querySelector('.ui-slider-range')
    const _left = vnode.dom.querySelector('.slider-left')
    const _right = vnode.dom.querySelector('.slider-right')

    this.rangeWidth = _range.offsetWidth
    let self = this
    interact(_left).draggable({
      axis: 'x',
      onmove: (event) => {
        const target = event.target
        let old = self.left
        self.left = (parseFloat(self.left) || 0) + event.dx
        if (self.getRangeWidth() < 2) {
          self.left = old
          return m.redraw()
        }
        if (self.left < 0) {
          self.left = 0
          return m.redraw()
        }
        target.style.webkitTransform = target.style.transform = `translate(${self.left}px,0px)`
        m.redraw()
      }
    })

    interact(_right).draggable({
      axis: 'x',
      onmove(event) {
        const target = event.target
        let old = self.right
        self.right = (parseFloat(self.right) || 0) + event.dx
        if (self.getRangeWidth() < 2) {
          self.right = old
          return m.redraw()
        }

        if (self.right > 0) {
          self.right = 0
          return m.redraw()
        }
        target.style.webkitTransform = target.style.transform = `translate(${self.right}px,0px)`
        m.redraw()
      }
    })

    this.init(_range, _left, _right)
  }
  ///初始值
  init(_range, _left, _right) {

    const _start = Math.round(this.start() / 175)
    _left.style.webkitTransform = _left.style.transform = `translate(${_start}px,0px)`
    this.left = _start

    const _end = Math.round((this.end() - 35100) / 175)
    _right.style.webkitTransform = _right.style.transform = `translate(${_end}px,0px)`
    this.right = _end

  }
  getRangeWidth() {
    const width = 100 - ((this.left / this.rangeWidth) * 100) + ((this.right / this.rangeWidth) * 100)
    return width
  }
  money(value, direction) {
    if (direction == 'left') {
      this.min(Math.round(value * 175))
      return Math.round(value * 175).toLocaleString("zh-TW")
    }

    const money = 35100 + Math.round(value * 175)
    this.max(money)
    return money.toLocaleString("zh-TW")
  }
  view() {

    return m("#search-price-range", [
      m('.ui-slider-range', {
        style: {
          left: `${(this.left / this.rangeWidth) * 100}%`,
          width: `${this.getRangeWidth()}%`
        }
      }),
      m('span.ui-slider-handle.slider-left', {
        style: {
          left: '-15px'
        }
      }, [
        m('span', `$${this.money(this.left, 'left')}`)
      ]),
      m('span.ui-slider-handle.slider-right', {
        style: {
          left: '100%'
        }
      }, [
        m('span', `$${this.money(this.right, 'right')}`)
      ]),
    ])
  }
}

export default RangeSlider